import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import GConf from '../../../AssetsM/generalConf';
import { ToWords } from 'to-words';

function BonsLivTemp(props) {
    let {date,cid,ste,mt} = useParams()
    let [articleL, setArticleL] = useState([])
    let [factureData, setFactData] = useState([])
    const toWords = new ToWords({
        localeCode: 'fr-FR',
        converterOptions: {
          //currency: true,
          ignoreDecimal: true,
          ignoreZeroCurrency: false,
          doNotAddOnly: false,
        }
      });
     const Companies = {
        mod : { Nom: 'Ste MOD', RIB : '9849849849498498'},
        saida : { Nom: 'Ste SAIDA', RIB : '896558985549498498'},
        judy : { Nom: 'Ste JUDY', RIB : '896558985549498498'},
     }

     const Socite = {
        asl : { Nom: 'Ste Fils Sghairi', RIB : '78928484098498'},
        as : { Nom: 'Ste ASLAM de commerce ', RIB : '01116140110000100739'},
     }

 

    return ( <>
        <div className='ps-2'>
           <div className="row" style={{marginTop : 45}}>
                <div style={{width : '41%'}}></div>
                <div style={{width : '35%'}}>
                    <div className='mb-2'>Bourouis <br /> {date} </div>
                </div>
                <div style={{width : '15%'}}></div>
            </div>
            <div className="row mt-1 mb-1">
                <div style={{width : '30%'}}></div>
                <div style={{width : '40%'}}>
                    <div className='mb-2'>{Socite[ste].RIB}</div>
                </div>
                <div style={{width : '20%'}}> {mt} </div>
            </div>
            <div className="row " style={{marginTop : 39}}>
                <div style={{width : '30%'}}></div>
                <div style={{width : '40%'}}>{Companies[cid].Nom}</div>
                <div style={{width : '20%'}}> {mt}</div>
            </div>
            <div className="row mt-2">
                <div style={{width : '10%'}}></div>
                <div style={{width : '90%'}}>
                        {toWords.convert(mt)} Dinar  
                </div>
            </div>
            <div className="row mt-4">
                <div style={{width : '5%'}}></div>
                <div style={{width : '12%'}}>Bourouis</div>
                <div style={{width : '20%'}}>{date}</div>
                <div style={{width : '50%'}}>  </div>
            </div>
            <div className="row mt-4">
                <div style={{width : '10%'}}></div>
                <div style={{width : '20%'}}>{Socite[ste].RIB}</div>
                <div style={{width : '40%'}}> </div>
                <div style={{width : '20%'}}> ATB Bourouis </div>
            </div>
        </div>      
    </> );
}

export default BonsLivTemp;